const INFERNAL_PLATE = {
  slug: "infernal-plate",
  name: "Infernal Plate",
  description: "Forged in the heart of a volcano",
  rarity: "epic",
  slot: "armor",
  shopCategory: "metal-armor",
  statChanges: [
    { stat: "armor", value: 30 },
    { stat: "redColor", value: 25 },
    { stat: "redRes", value: 12 }
  ],
  sprite: {
    sheet: "wardrobe/metal/metal_red",
    frameIndex: 3
  },
  bodySprite: "characters/body/body_red",
  tags: ["daily-rotation", "metal"]
};
export {
  INFERNAL_PLATE
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL2FybW9ycy9tZXRhbC9pbmZlcm5hbC1wbGF0ZS50cyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiaW1wb3J0IHsgSXRlbURlZmluaXRpb24gfSBmcm9tICcuLi8uLi90eXBlcyc7XG5cbmV4cG9ydCBjb25zdCBJTkZFUk5BTF9QTEFURTogSXRlbURlZmluaXRpb24gPSB7XG4gIHNsdWc6ICdpbmZlcm5hbC1wbGF0ZScsXG4gIG5hbWU6ICdJbmZlcm5hbCBQbGF0ZScsXG4gIGRlc2NyaXB0aW9uOiAnRm9yZ2VkIGluIHRoZSBoZWFydCBvZiBhIHZvbGNhbm8nLFxuICByYXJpdHk6ICdlcGljJyxcbiAgc2xvdDogJ2FybW9yJyxcbiAgc2hvcENhdGVnb3J5OiAnbWV0YWwtYXJtb3InLFxuICBzdGF0Q2hhbmdlczogW1xuICAgIHsgc3RhdDogJ2FybW9yJywgdmFsdWU6IDMwIH0sXG4gICAgeyBzdGF0OiAncmVkQ29sb3InLCB2YWx1ZTogMjUgfSxcbiAgICB7IHN0YXQ6ICdyZWRSZXMnLCB2YWx1ZTogMTIgfSxcbiAgXSxcbiAgc3ByaXRlOiB7XG4gICAgc2hlZXQ6ICd3YXJkcm9iZS9tZXRhbC9tZXRhbF9yZWQnLFxuICAgIGZyYW1lSW5kZXg6IDMsXG4gIH0sXG4gIGJvZHlTcHJpdGU6ICdjaGFyYWN0ZXJzL2JvZHkvYm9keV9yZWQnLFxuICB0YWdzOiBbJ2RhaWx5LXJvdGF0aW9uJywgJ21ldGFsJ10sXG59O1xuIl0sCiAgIm1hcHBpbmdzIjogIkFBRU8sTUFBTSxpQkFBaUM7QUFBQSxFQUM1QyxNQUFNO0FBQUEsRUFDTixNQUFNO0FBQUEsRUFDTixhQUFhO0FBQUEsRUFDYixRQUFRO0FBQUEsRUFDUixNQUFNO0FBQUEsRUFDTixjQUFjO0FBQUEsRUFDZCxhQUFhO0FBQUEsSUFDWCxFQUFFLE1BQU0sU0FBUyxPQUFPLEdBQUc7QUFBQSxJQUMzQixFQUFFLE1BQU0sWUFBWSxPQUFPLEdBQUc7QUFBQSxJQUM5QixFQUFFLE1BQU0sVUFBVSxPQUFPLEdBQUc7QUFBQSxFQUM5QjtBQUFBLEVBQ0EsUUFBUTtBQUFBLElBQ04sT0FBTztBQUFBLElBQ1AsWUFBWTtBQUFBLEVBQ2Q7QUFBQSxFQUNBLFlBQVk7QUFBQSxFQUNaLE1BQU0sQ0FBQyxrQkFBa0IsT0FBTztBQUNsQzsiLAogICJuYW1lcyI6IFtdCn0K
